import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { LocalDataSource } from 'ng2-smart-table';
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
import { Lists_loaikhoan, Lists_tieumuc, Lists_nguonkinhphi, Lists_danhmucdonvibanle, Ultil_donvi } from '../../../routes/menu'

const swal = require('sweetalert');


@Component({
    selector: 'app-tonghop-chontaikhoannganhangedit',
  templateUrl: './chontaikhoannganhangedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./chontaikhoannganhangedit.component.scss'],
    providers: [ListService, Repository]
})


export class chontaikhoannganhangeditComponent implements OnInit {

  @ViewChild('modaldonvile', { static: false }) modaldonvile: ModalComponent;
  @ViewChild('dtedonvile', { static: false }) dtedonvile: any;
  
  @Output() save: EventEmitter<any> = new EventEmitter();
  datas: any;
  data: any;

  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    DonViId: null
    , CapDonViId: null
    , UserName: null
    , TuNgay: null
    , DenNgay: null
    , TimKiem: null
    , startPage: null
    , endPage: null
    , curPage: null
    , HoVaTen: null
    , MaNV: null
    , Ngay: null
    , NgayS: null
    , SoCMND: null
    , IDGioiTinh: null
    , DiaChi: null
    , PhongBan: null
    , DonVi: null
    , MaKhoanLuong: null
    , NgayApDung: null
    , NgayApDungS: null
    , HeSo: null
    , SoTien: null
    , LoaiNhanVienId: null
    , SoHieu: null
    , TaiKhoan: null
    , HoTen: null
    , BiDanh: null
    , TrangThai: null
    , TrangThaiS: null
    , NgaySinh: null
    , NgaySinhS: null
    , TenCapDonVi: null
    , TenPhuHuynh: null
    , SoDienThoai: null
    , PhuTrach: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , SapXep: null
    , MaDonVi: null
    , TenDonVi: null
    , CapTren: null
    , CapDonVi: null
    , ThuTu: null
    , Id: null
    , KhachHangNhaCungCapId: null
    , SoTaiKhoan: null
    , NganHang: null
    , ChuTaiKhoan: null
    , ChiNhanh: null
    , GhiChu: null


  };
  public ngaytimkiem: Date = new Date();
  public ngaytimkiem2: Date = null;
  public ngaytimkiem3: Date = null;
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }
  public changeTrangThai($event: any) {
    if (typeof $event === "undefined") {
      this.TimKiems.TrangThai = null;
      this.search();
    }
    else {
      this.TimKiems.TrangThai = $event.Id;
      this.search();
    }
  }

  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  public TuNgay1: Date = new Date();
  public DenNgay1: Date = new Date();
  public tTuNgay: string;
  public tDenNgay: string;

 

 
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  phanheid: any;
  lopid: string;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  quyen_them: boolean = false;
  mabaocao: string;
  loadDataInit(id: string, pheid: string, mabaocao: string, capdonviid: number, donviid: number) {
    this.mabaocao = mabaocao;
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.phanheid = pheid;
    this.TimKiems.CapDonViId = capdonviid;
    this.TimKiems.DonViId = donviid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      //this.donviid = this.currentUser.id_don_vi;
      //this.TimKiems.DonViId = this.donviid;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      //var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.phanheid.toLowerCase());
      //if (giatri != null && giatri.length > 0) {
      //  if (giatri[0].Them == true)
      //    this.quyen_them = true;
      //  else
      //    this.quyen_them = false;
        
      //}
     
      
    }

   
    this.search();
        
    
  }

  
  adddata() {
    this.dtedonvile.loadDataInit(Ultil_donvi.id, null, this.TimKiems.DonViId);
    this.modaldonvile.open();
  } 


  editdata(id: string) {
    this.dtedonvile.loadDataInit(Ultil_donvi.id, id, this.TimKiems.DonViId);
    this.modaldonvile.open();
  }

  
  saveModal(id: any) {
    this.Loaddatas();
    this.modaldonvile.close();
  }

  
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas();
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 50;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }
  Loaddatas(): void {
    //this.indLoading = true;
    //this.repo.postRequest("api/chungtu/get_chungtulistviewv2/", { id: this.donviid, chuoi: this.phanheid, chuoi1: this.username, status: this.namketoan, chuoi2: '1', chuoi3: this.idchungtu })
    //  .subscribe(response => {
    //    console.log(response);
    //    this.datas = response;
    //    this.source.load(response);
    //  });

    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    //this.TimKiems.DonViId = this.donviid;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiems.NgaySinhS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiems.NgaySinhS = null;

    //if (this.ngaytimkiem2 != null) {
    //  this.TimKiems.NgayChungTuS = this.ngaytimkiem2.getFullYear() + '-' + (this.ngaytimkiem2.getMonth() + 1) + '-' + this.ngaytimkiem2.getDate();
    //}
    //else
    //  this.TimKiems.NgayChungTuS = null;

    if (this.ngaytimkiem3 != null) {
      this.TimKiems.ModifiedS = this.ngaytimkiem3.getFullYear() + '-' + (this.ngaytimkiem3.getMonth() + 1) + '-' + this.ngaytimkiem3.getDate();
    }
    else
      this.TimKiems.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };
    //$('#loading').show();
    this.repo.postRequest("api/taikhoannganhang/get_listviewpage/", this.TimKiems)
      .subscribe(response => {
        //$('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          let start, end;

          if (this.totalPages <= 4) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 2) {
              start = 1;
              end = 4;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 3;
              end = this.totalPages;
            } else {
              start = this.currentPage - 1;
              end = this.currentPage + 1;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;


        (window as any).timer(4, 1000);



      });


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

  public save_chondoituong2(item: any) {
    let tdoituong = [];
    tdoituong.push(item);
    this.save.emit(tdoituong);
  }
  public save_chondoituong() {  
    let tdoituong = [];
    this.save.emit(tdoituong);

  

  }
  closeModal_chondoituong() {
    let tdoituong =null;
    this.save.emit(tdoituong);
  }
  nhomdoituongid: string;
  onLoaiNguoiNop(row: any) {
    this.nhomdoituongid = row.Id;
    //console.log(loai);
  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
   
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }


  

  deletedata(id: string) {
    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.getRequest('api/taikhoannganhang/delete/' + id).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');
                this.Loaddatas();
              }
              else {
                // this.msg = data;
                alert(data);
              }
            }
          );
        }
      });


  }

  
  

}
